import axios from 'axios'
import { DocumentResponse } from '../../../../api/models'
import { CreateDocumentRequestV3 } from '../../../../api/models/create-document-request-v3'
import { UpdateDocumentRequestV3 } from '../../../../api/models/update-document-request-v3'

const baseUrl = process.env.REACT_APP_API_URL

export async function fetchConsignmentDocumentsV3(
  params: { consignmentId: number; documentType?: string },
  opts?: { signal?: AbortSignal },
) {
  const { data } = await axios.get<DocumentResponse[]>(`${baseUrl}/v3/consignment/${params.consignmentId}/documents`, {
    signal: opts?.signal,
    params: {
      documentType: params.documentType,
    },
  })

  return data
}

export async function createConsignmentDocumentsV3(
  consignmentId: number,
  documents: CreateDocumentRequestV3[],
) {
  const { data } = await axios.post<DocumentResponse[]>(`${baseUrl}/v3/consignment/${consignmentId}/documents`, documents)
  return data
}

export async function updateConsignmentDocumentsV3(
  consignmentId: number,
  documents: UpdateDocumentRequestV3[],
) {
  const { data } = await axios.put<DocumentResponse[]>(`${baseUrl}/v3/consignment/${consignmentId}/documents`, documents)
  return data
}
